import React, { useEffect, createElement } from 'react';
import { CheckIcon } from 'lucide-react';
export function FormularioSection() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://link.msgsndr.com/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  const items = ['Planilla digital del Mapa de Fugas (lista para usar hoy)', 'Instructivo paso a paso (15 minutos para llenarlo)'];
  return <section id="formulario" className="bg-white py-16 md:py-24 px-4 scroll-mt-8" data-id="element-50">
      <div className="max-w-4xl mx-auto" data-id="element-51">
        <div className="text-center mb-12" data-id="element-52">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-53">
            Descarga GRATIS el Mapa de Fugas de Tiempo
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start" data-id="element-54">
          <div className="bg-gray-50 p-8 rounded-2xl border border-gray-100" data-id="element-55">
            <p className="text-xl font-bold text-gray-900 mb-6" data-id="element-56">Recibirás:</p>
            <ul className="space-y-4 mb-8" data-id="element-57">
              {items.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-58">
                  <CheckIcon className="w-6 h-6 text-[#D90B10] flex-shrink-0 mt-0.5" data-id="element-59" />
                  <span className="text-lg text-gray-800" data-id="element-60">{item}</span>
                </li>)}
            </ul>
            <p className="text-sm italic text-gray-600 border-t border-gray-200 pt-6" data-id="element-61">
              La mayoría descubre entre 2 y 4 horas diarias de fugas. No más
              horas. Horas que ya tenías — y no estabas viendo.
            </p>
          </div>

          <div className="w-full min-h-[400px] bg-white rounded-xl shadow-sm border border-gray-100 p-2" data-id="element-62">
            <iframe src="https://api.leadconnectorhq.com/widget/form/PTRuOq4WwqKVjhFPDEQ7" style={{
            width: '100%',
            border: 'none',
            overflow: 'hidden',
            minHeight: '400px'
          }} scrolling="no" id="inline-PTRuOq4WwqKVjhFPDEQ7" title="Formulario de descarga" data-id="element-63"></iframe>
          </div>
        </div>
      </div>
    </section>;
}